<script>
import useSharedData from "@/use/SharedData";
import useTools from "@/use/Tools";
import {usePaySlipAnnexStore} from "@/stores/PaySlipAnnex";
import useSharedMethod from "@/use/SharedMethod";
import {onMounted, ref} from "vue";
import axios from "axios";

export default {
    setup() {
        const {dialog, loading, overlay} = useSharedData();
        const {$route} = useTools();
        const {getBack} = useSharedMethod();
        const annex = ref({});

        const paySlipAnnexStore = usePaySlipAnnexStore();

        function findById(id) {
            loading.value = true;
            axios.get(`/paySlipAnnexes/${id}`).then(response => {
                annex.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function remove() {
            loading.value = true;
            axios.delete(`/paySlipAnnexes/${annex.value.id}`).then(() => {
                paySlipAnnexStore.deletePaySlipAnnex(annex.value);
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }

        onMounted(() => findById($route.params.id));

        return {
            dialog,
            loading,
            overlay,
            annex,
            getBack,
            remove,
        }
    }
};
</script>

<template>
        <v-dialog
            v-model="dialog"
            persistent
            scrollable
            max-width="600"
        >
            <v-card flat>
                <w-overlay
                    :loading="loading"
                    :overlay="overlay"
                    delete-action
                    @cancel="overlay = false"
                    @remove="remove"
                ></w-overlay>
                <w-toolbar color="red" :title="$t('common.delete')"/>
                <v-card-text>
                    <v-row align="center" justify="center" style="height: 200px;">
                        <h2 class="text-center">
                            {{ $t('pay_slip.ask_for_remove') }}
                            <span class="red--text">{{ annex.name }}</span>
                        </h2>
                    </v-row>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="getBack"/>
                    <w-btn-delete
                        show
                        :loading="loading"
                        @press="overlay = true"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>